import * as angular from "angular";
import {IController} from "angular";

export class FilterSearchInputComponent implements IController {
  query: any;
  isDisabled: any;
  placeholder: any;
  minLength: number;
  queryChanged: Function;

  constructor() {
  }

  changeQuery(query) {
    if (!query || !this.minLength || query.length >= this.minLength) {
      this.queryChanged({query: query});
    }
  }

  clear() {
    if (this.query) {
      this.query = undefined;
      this.queryChanged({query: ''});
    }
  }
}

angular
  .module('bringoz.admin.commons')
  .component('filterSearchInput', {
    bindings: {
      query: '<',
      isDisabled: '<?',
      placeholder: '@',
      minLength: '<?',
      queryChanged: '&'
    },
    templateUrl: 'app/modules/commons/components/filter-search-input/filter-search-input.html',
    controller: FilterSearchInputComponent
  });
